import { INavStyles } from '@fluentui/react';

import { IH2OTheme } from '../../models/components.models';
import { FontSizes, FontWeights, Sizes } from '../../themes/styles';

export const navStylesDefault = (theme: IH2OTheme): Partial<INavStyles> => ({
  compositeLink: {
    height: Sizes.height,
    lineHeight: Sizes.height,
    color: theme.semanticColors?.textQuaternary,
    '&.is-selected': {
      '.ms-Nav-link': {
        backgroundColor: theme.palette?.primary500,
        fontWeight: FontWeights.normal,
        color: theme.palette?.textOverPrimary,
      },
    },
    ':hover.is-selected': {
      '.ms-Nav-link': {
        backgroundColor: theme.palette?.primary500,
      },
    },
  },
  linkText: { margin: 0 },
  link: {
    height: Sizes.height,
    lineHeight: Sizes.height,
    borderRadius: Sizes.borderRadius,
    color: theme.semanticColors?.textQuaternary,
    paddingRight: Sizes.padding,
    ':hover': {
      color: theme.semanticColors?.textQuaternary,
      '.ms-Icon': { color: theme.semanticColors?.textQuaternary },
    },
    '::after': {
      border: 0,
    },
    '&.is-disabled': {
      color: theme.semanticColors?.textDisabled,
      cursor: 'default',
    },
    '.ms-Icon': {
      fontSize: FontSizes.button,
      color: theme.semanticColors?.textQuaternary,
      margin: 0,
      marginRight: 8,
    },
    '.ms-Button-flexContainer': {
      // link has padding 3px on the left
      paddingLeft: 13,
    },
  },
  chevronIcon: {
    height: Sizes.height,
    lineHeight: Sizes.height,
    fontSize: FontSizes.button,
    width: 14,
    left: 0,
  },
  chevronButton: {
    right: Sizes.padding,
    left: 'auto',
    top: 0,
    height: Sizes.height,
    lineHeight: Sizes.height,
    backgroundColor: 'transparent',
    color: theme.semanticColors?.textQuaternary,
    '::after': {
      border: 0,
    },
  },
  groupContent: {
    marginBottom: 0,
  },
  group: {
    h3: {
      marginTop: 0,
    },
  },
});

export const navStylesNoDepth: Partial<INavStyles> = {
  link: {
    paddingLeft: Sizes.padding,
    '.ms-Button-flexContainer': {
      paddingLeft: 0,
    },
  },
};

export const navStylesSecondary = (theme: IH2OTheme): Partial<INavStyles> => ({
  group: {},
  link: {
    paddingLeft: '8px',
    color: theme.semanticColors?.textSecondary,
    '.ms-Button-flexContainer': {
      paddingLeft: 0,
    },
    '.ms-Icon': {
      color: theme.semanticColors?.textSecondary,
    },
  },
  chevronButton: {
    borderBottom: 0,
    fontSize: FontSizes.xxsmall,
    color: theme.semanticColors?.textSecondary,
    margin: 0,
    marginBottom: '4px',
    marginTop: Sizes.padding,
    padding: 0,
    right: 0,
    height: '15px',
    lineHeight: '15px',
  },
  chevronIcon: {
    right: Sizes.padding,
    left: 'auto',
    height: '15px',
    lineHeight: '15px',
  },
  compositeLink: {
    '&.is-selected': {
      '.ms-Nav-link': {
        backgroundColor: theme.semanticColors?.buttonActiveBackground,
        fontWeight: FontWeights.fw500,
      },
    },
    ':hover.is-selected': {
      '.ms-Nav-link': {
        backgroundColor: theme.semanticColors?.buttonActiveBackground,
      },
    },
  },
});
